(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cws-product-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-cws-preview-timer]:not([data-cws-initialized])').forEach(timer => {
        timer.dataset.cwsInitialized = 'true';
        const expiresAt = Date.now() + (5 * 3600 + 13 * 60 + 19) * 1000;
        const tick = () => {
          if (!timer.isConnected) return false;
          const remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
          const parts = [Math.floor(remaining / 3600), Math.floor((remaining % 3600) / 60), remaining % 60];
          timer.textContent = parts.map(part => String(part).padStart(2, '0')).join(':');
          return remaining > 0;
        };
        tick();
        const interval = setInterval(() => { if (!tick()) clearInterval(interval); }, 1000);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
